import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const XIcon = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="brand-x" clipPath="url(#clip0_3001_4881)">
        <path
          id="Vector (Stroke)"
          d="M0.550093 0.774111C0.635261 0.606042 0.807679 0.500122 0.996096 0.500122H4.72972C4.889 0.500122 5.03874 0.576005 5.13293 0.704446L9.13167 6.15744L14.6425 0.646569C14.8378 0.451307 15.1544 0.451307 15.3496 0.646569C15.5449 0.841831 15.5449 1.15841 15.3496 1.35368L9.72999 6.97334L15.3993 14.7044C15.5107 14.8564 15.5273 15.0581 15.4421 15.2261C15.3569 15.3942 15.1845 15.5001 14.9961 15.5001H11.2625C11.1032 15.5001 10.9535 15.4242 10.8593 15.2958L6.86052 9.84281L1.34965 15.3537C1.15439 15.5489 0.837805 15.5489 0.642543 15.3537C0.447281 15.1584 0.447281 14.8418 0.642543 14.6466L6.26221 9.0269L0.59289 1.2958C0.481469 1.14386 0.464924 0.94218 0.550093 0.774111ZM8.63456 7.17058C8.6538 7.20478 8.67738 7.2372 8.70529 7.26703L14.0094 14.5001H11.5158L1.98278 1.50012H4.47635L8.63456 7.17058Z"
          fillRule="evenodd"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="clip0_3001_4881">
          <rect width="16" height="16" />
        </clipPath>
      </defs>
    </svg>
  );
};

XIcon.displayName = 'XIcon';
